import { render, staticRenderFns } from "./story-prof-item.vue?vue&type=template&id=49af94d6&"
import script from "./story-prof-item.vue?vue&type=script&lang=js&"
export * from "./story-prof-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports